var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.165 -0.000976562C10.9102 -0.000976562 0.165039 10.7442 0.165039 23.999C0.165039 37.2539 10.9102 47.999 24.165 47.999C37.4199 47.999 48.165 37.2539 48.165 23.999C48.165 10.7442 37.4199 -0.000976562 24.165 -0.000976562ZM17.6075 34.4376V13.5604L35.6877 23.999L17.6075 34.4376Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.165039 -0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.3cddb986b6cabf88d2e381f2c9b06602.svg";
export { ForwardRef as ReactComponent };